<template>
  <div class="item-wish">
    <a v-if="!brandActive" class="btn-wish" href="#" @click.prevent="toggleFollow">
      <i class="icon-heart" />
    </a>
    <a v-else class="btn-wish" href="#" @click.prevent="toggleFollow">
      <i class="icon-heart icon-heart-active" />
    </a>
  </div>
</template>

<script setup>
import $ from 'jquery';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

const { postBrandFollowAPI, deleteBrandFollowAPI } = useAxiosAPI();

$('.brand-list')
  .off('click')
  .on('click', '.icon-heart', function () {
    const currentBrand = $(this).parents('.item-wish').siblings('a').html();
    if ($(this).not('icon-heart-active')) {
      $('.brand-name a').each(function (e) {
        const childBrand = $(this).html();
        if (childBrand === currentBrand) {
          $(this)
            .siblings('.item-wish')
            .children('.btn-wish')
            .children('.icon-heart')
            .removeClass('icon-heart-active');
        }
      });
    }
  });

const emit = defineEmits(['update']);

const props = defineProps({
  brandActive: {
    type: Boolean,
    default: false,
  },
  brandCode: {
    type: String,
    default: '',
  },
  notUpdate: {
    type: Boolean,
    default: false,
  },
});

function toggleFollow(event) {
  if (props.notUpdate) {
    return;
  }
  const isFavorite = event.target.classList.contains('icon-heart-active');
  if (!isFavorite) {
    postBrandFollowAPI({
      BrandCode: props.brandCode,
    })
      .then((res) => {
        if (res.data.Code === 200) {
          event.target.classList.add('icon-heart-active');
          emit('update');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } else {
    deleteBrandFollowAPI({
      data: {
        BrandCode: props.brandCode,
      },
    })
      .then((res) => {
        if (res.data.Code === 200) {
          event.target.classList.remove('icon-heart-active');
          emit('update');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
</script>
